import React from "react";
import GoodSamaritanGuide from "../GoodSamaritanGuide";

const PublicGoodSamaritanSection = ({ onStartRescue }) => (
  <section className="pub-samaritan-wrap" aria-label="Good Samaritan information">
    <GoodSamaritanGuide onStartRescue={onStartRescue} />
  </section>
);

export default PublicGoodSamaritanSection;
